import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import '../styles/Roadmap.css';

const roadmapData = [
  {
    title: '🌑 Phase 1: Rise of the Undead (Community Reactivation)',
    content: [
      "Open Discord with new structure (Elite Holders Chat, Role-based Access)",
      "Reactivate holders via Testnet OG benefits and re-engagement posts",
      "Run “Builder Quests” to empower holders to contribute:",
      "↳ Collab outreach (via X posts + ticketing)",
      "↳ Lore/character creation tasks",
      "↳ Design submissions (e.g., sticker, teaser trailer, etc.)",
      "↳ Weekly Twitter spaces + sneak peeks",
      "↳ Feature updated AI tools utility for holders"
    ]
  },
  {
    title: '🚀 Phase 2: Mint of the Fallen',
    content: [
      "Launch 3333 Genesis Mint at ~$",
      "50% of mint funds staked in DAO treasury wallet",
      "25% allocated to the team for farming airdrop",
      "15% to creative/marketing budget",
      "10% to core team",
      "Mint holders get:",
      "↳ Role-based Discord perks",
      "↳ Character customizations",
      "↳ Access to AI tools & lore builder",
      "↳ Whitelist for future seasons"
    ]
  },
  {
    title: '⚔️ Phase 3: War of Chains',
    content: [
      "Introduce factions within Legion (e.g., Order of Bonefire, Ghost Runners, Codebound)",
      "Hold Faction Wars (onchain + offchain games + community events)",
      "Launch animated teaser trailer",
      "Darkchain Treasury vote (holders suggest how staked funds evolve project)",
      "Open Lore Gallery for Darkchain Bios (community co-written)"
    ]
  },
  {
    title: '🌌 Phase 4: Expansion Beyond the Grave',
    content: [
      "Cross-collab with other NFT projects via X and Discord",
      "Launch AI-based story generator (Legion lore builder)",
      "Partner with L2 chains for faction-specific quests",
      "Limited-edition Terra Pack drop (inspired by Monad ecosystem planets)",
      "First round of physical collectibles & physical packs"
    ]
  }
];

function Roadmap() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <motion.div
      className="roadmap-page"
      initial={{ opacity: 0, x: -30 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.9, ease: 'easeOut' }}
    >
      <h1>Dark Monad Roadmap</h1>
      <p>
        Our 4-phase journey toward a community-driven, AI-powered NFT ecosystem:
      </p>

      <div className="roadmap-steps">
        {roadmapData.map((item, index) => (
          <div key={index} className="roadmap-step">
            <div className="phase-header" onClick={() => toggleIndex(index)}>
              <span>{item.title}</span>
              <span className={`icon ${openIndex === index ? 'rotated' : ''}`}>
                {openIndex === index ? '−' : '+'}
              </span>
            </div>

            <AnimatePresence initial={false}>
              {openIndex === index && (
                <motion.div
                  className="phase-tasks"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.4, ease: 'easeInOut' }}
                >
                  {item.content.map((line, i) => {
                    if (line.startsWith("↳")) {
                      return (
                        <p key={i} style={{ marginLeft: '1rem', color: '#aaa' }}>
                          {line}
                        </p>
                      );
                    } else if (line.endsWith(":")) {
                      return (
                        <p key={i} style={{ fontWeight: 'bold', marginTop: '1rem' }}>
                          {line}
                        </p>
                      );
                    } else {
                      return <p key={i}>{line}</p>;
                    }
                  })}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>

      <h2 className="tagline">The future is Dark. The future is AI.</h2>
    </motion.div>
  );
}

export default Roadmap;
